var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlantSmallTag = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M53.2 53.8V15.5H42.8v38.4c0 .7.1 1.3.3 1.9.6 1.7 1.9 5.2 3.3 7.3 0 0 1.4 3.4 3.1 0 0 0 1.2-1.5 3.2-7.3.3-.7.5-1.3.5-2z"
  })));
};
export default SvgPlantSmallTag;